import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, throwError, timer } from 'rxjs'
import { catchError, retry } from 'rxjs/operators'

@Injectable()
export class RetryInterceptor implements HttpInterceptor {
    private readonly maxRetries = 3 // Maximum number of retries
    private readonly retryDelayMs = 500 // Delay between retries in milliseconds

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            retry({
                count: this.maxRetries,
                delay: (error: HttpErrorResponse, retryAttempt: number): Observable<number> => {
                    // if maximum number of retries have been met
                    // or response is a status code we don't wish to retry, throw error
                    if (retryAttempt > this.maxRetries || this.shouldRetry(error) === false) {
                        return throwError(() => error)
                    }
                    console.log(`Attempt ${retryAttempt}: retrying in ${retryAttempt * this.retryDelayMs}ms`)
                    return timer(retryAttempt * this.retryDelayMs)
                },
            }),
            catchError((error) => {
                console.error('Request failed after retries:', error)
                return throwError(() => error)
            })
        )
    }

    private shouldRetry(error: any): boolean {
        if (error instanceof HttpErrorResponse) {
            // Retry on 5xx server errors or connectivity-related errors (status === 0)
            return error.status >= 500 || error.status === 0
        }
        return false
    }
}
